import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttributeValidationMeshPort } from '../../../domain/commerce-registry/ports/attribute-validation-mesh.port';
import type { UsuarioAttributeValidationRule } from '../../../domain/commerce-registry/models/usuario-attribute-validation.model';
import { ENVIRONMENT } from '../../../../environments/environment';

/** Raw API row (CNF attribute-validator). */
interface AttributeValidatorApiRow {
  id_validacion: number;
  nombre_validacion: string;
  descripcion_validacion: string;
  expresion_regex: string;
  id_atributo: number;
  nombre_atributo: string;
  nombre_entidad: string;
  obligatorio: boolean;
  activo: boolean;
  id_pais: number | null;
  nombre_pais: string | null;
  external_code: number | null;
}

@Injectable()
export class AttributeValidationMeshApiAdapter extends AttributeValidationMeshPort {
  constructor(private readonly http: HttpClient) {
    super();
  }

  loadByCountry(codPais: string): Observable<UsuarioAttributeValidationRule[]> {
    const base = ENVIRONMENT.apiBaseLeal?.trim();
    if (!base) {
      return throwError(
        () => new Error('attribute_validation_mesh: apiBaseLeal is not configured'),
      );
    }

    const code = codPais.trim();
    if (!code) {
      return throwError(() => new Error('attribute_validation_mesh: country code is empty'));
    }

    const url = `${base.replace(/\/$/, '')}/v1/api/cnf/attribute-validator/entities/usuario/countries/${encodeURIComponent(code)}`;

    return this.http.get<AttributeValidatorApiRow[] | { data?: AttributeValidatorApiRow[] }>(url).pipe(
      map((res) => {
        const rows = Array.isArray(res) ? res : res?.data;
        return Array.isArray(rows) ? rows.map(mapRow) : [];
      }),
    );
  }
}

function mapRow(row: AttributeValidatorApiRow): UsuarioAttributeValidationRule {
  return {
    validationId: row.id_validacion,
    validationName: row.nombre_validacion ?? '',
    description: row.descripcion_validacion ?? '',
    regex: row.expresion_regex ?? '',
    attributeId: row.id_atributo,
    attributeName: row.nombre_atributo ?? '',
    entityName: row.nombre_entidad ?? '',
    required: !!row.obligatorio,
    active: !!row.activo,
    countryId: row.id_pais,
    countryName: row.nombre_pais,
    externalCode: row.external_code,
  };
}
